export function track(key) {
  try {
    fbq('track', key);
  } catch (e) {
  }
}
